// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import 'font-awesome/css/font-awesome.css';
import './theme/default.styl';
import VueProgressiveImage from 'vue-progressive-image';
import createPersistedState from 'vuex-persistedstate';
import VueCroppie from 'vue-croppie';
import VueMoment from 'vue-moment';
import moment from 'moment';
require('moment/locale/pt-br');
import axios from 'axios';
import Vuetify from 'vuetify';
import pt from 'vuetify/es5/locale/pt';
import colors from 'vuetify/es5/util/colors';
import Truncate from 'lodash.truncate';
import VeeValidate, { Validator } from 'vee-validate';
import pt_BR from 'vee-validate/dist/locale/pt_BR';
import money from 'v-money';
import currency from 'v-currency-field'
// import 'v-currency-field/dist/index.css'

Vue.use(currency)
Vue.use(money, {
	decimal: ',',
	thousands: '.',
	// prefix: 'R$ ',
	suffix: ' #',
	precision: 2,
	masked: false
});


Vue.use(VueProgressiveImage);

Vue.use(VueCroppie);

Vue.use(VueMoment, {
  moment,
});

createPersistedState({
  key: 'vuex',
  paths: [],
  storage: window.localStorage
})(store);
const axiosConfig = {
  baseURL: process.env.API_URL || 'http://api.emm.labcinco.com/v1/private',
  timeout: 30000
}
Vue.prototype.$axios = axios.create(axiosConfig);
Vue.prototype.$axios.interceptors.request.use(config => {
  // Do something before request is sent
  config.headers.Authorization = 123456;
  config.headers.Token = store.getters.user ? store.getters.user.token : null;
  return config;
}, error => {
  // Do something with request error
  return Promise.reject(error);
});
Vue.prototype.$axios.interceptors.response.use(response => {
  return response;
}, error => {
  if (error && error.response && error.response.status) {
    if (error.response.status === 401) {
      window.getApp.$emit('APP_AUTH_FAILED');
    } else if (error.response.status === 403) {
      window.getApp.$emit('APP_ACCESS_DENIED');
    } else if (error.response.status === 500) {
      window.getApp.$emit('APP_BAD_REQUEST');
    }
  }
  return Promise.reject(error);
});

Vue.config.productionTip = false;
// Helpers
// Global filters
Vue.filter('truncate', Truncate);

Validator.localize('pt_BR', pt_BR);
Vue.use(VeeValidate, { fieldsBagName: 'formFields', locale: 'pt_BR' });


Vue.use(Vuetify, {
  theme: {
    primary: '#D0021B',
    vermelho: '#D0021B',
    verde: '#4CCC92',
    azul: '#18AFC5',
    cinza_footer1: '#26282A',
    cinza_footer2: '#1C1D1F',
    cinza_navbar: '#FDFDFD',
    body: '#FAFBFC'
  },
  lang: {
    locales: { pt },
    current: 'pt'
  },
  options: {
    themeVariations: ['primary', 'secondary', 'accent'],
    extra: {
      mainToolbar: {
        color: 'primary',
      },
      sideToolbar: {
      },
      sideNav: 'primary',
      mainNav: 'primary lighten-1',
      bodyBg: '',
    }
  }
});
// Bootstrap application components



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js